import React from 'react';
import { portraitImage } from '../data/education';
interface PortraitFrameProps {
  tone?: 'dark' | 'light';
}

/**
 * Ornamented portrait plate: double bronze rule, mitred corner marks and an
 * engraved name plate beneath the image.
 */
export function PortraitFrame({
  tone = 'dark'
}: PortraitFrameProps) {
  const isDark = tone === 'dark';
  return <figure className={`relative mx-auto w-full max-w-sm border p-3 ${isDark ? 'border-gold/40 bg-indigo/60' : 'border-gold/50 bg-white'}`} data-id="element-153" data-mp="1kljz48lq1tc4">
      <Corner className="left-1.5 top-1.5 border-l border-t" data-id="element-154" data-mp="2d9fpywom0r0z" />
      <Corner className="right-1.5 top-1.5 border-r border-t" data-id="element-155" data-mp="28h4ovqi4uz6u" />
      <Corner className="bottom-1.5 left-1.5 border-b border-l" data-id="element-156" data-mp="28fbjsfn64n0y" />
      <Corner className="bottom-1.5 right-1.5 border-b border-r" data-id="element-157" data-mp="23hjsnnucl4xt" />

      <div className="border border-gold/60 p-2" data-id="element-158" data-mp="30xfk86l4qzkb">
        <div className="overflow-hidden border border-gold/30" data-id="element-159" data-mp="30z0c1og284eh">
          <img src={portraitImage} alt="Portrait of Rear Admiral (Ret.) Gregory J. Slavonic in a dark suit before the United States flag" className="aspect-[4/5] w-full object-cover object-top" data-id="element-160" data-mp="2w6qnabqolads" />
        </div>

        <figcaption className={`mt-4 border-t px-2 pb-2 pt-4 text-center ${isDark ? 'border-gold/40' : 'border-gold/50'}`} data-id="element-161" data-mp="1sk2yo0bw4mtc">
          <span className={`block font-serif text-2xl leading-tight ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-162" data-mp="1iqvwspgczoy0">
            Gregory J. Slavonic
          </span>
          <span className="mt-2 flex items-center justify-center gap-3" data-id="element-163" data-mp="18vlx48dfntne">
            <span className="h-px w-6 bg-gold" data-id="element-164" data-mp="uvjegjxaww73" />
            <span className="text-[10px] font-semibold uppercase tracking-overline text-gold-light" data-id="element-165" data-mp="uwuh2gf0fxwm">
              Rear Admiral, U.S. Navy (Ret.)
            </span>
            <span className="h-px w-6 bg-gold" data-id="element-166" data-mp="2p928hjs4hwnn" />
          </span>
          <span className={`mt-3 block text-sm leading-relaxed ${isDark ? 'text-slate-300' : 'text-charcoal'}`} data-id="element-167" data-mp="2u7vp3l2pi3s1">
            Former Acting Under Secretary of the Navy &middot; Board Director &middot;
            President &amp; CEO, Blue-Water Strategies
          </span>
        </figcaption>
      </div>
    </figure>;
}
function Corner({
  className
}: {
  className: string;
}) {
  return <span aria-hidden="true" className={`pointer-events-none absolute h-4 w-4 border-gold ${className}`} data-id="element-168" data-mp="2dv0lq1aani1h" />;
}